import * as React from 'react';
import classnames from 'classnames';
import './index.scss';

interface Props {
    children?: React.ReactNode;
    indent?: '0' | '5' | '10' | '15' | '20' | '30' | '40' | '50' | '80' | '100' | '150'
}

const Block = (props: Props) => (
    <div className={classnames('block', {[`m-${props.indent}`]: props.indent} )}>{props.children}</div>
);

export default Block;


// WEBPACK FOOTER //
// ./src/components/layout/Block/index.tsx